import { render } from "./GroupMeeting.vue?vue&type=template&id=56c5b50a&scoped=true&ts=true"
import script from "./GroupMeeting.vue?vue&type=script&lang=ts"
export * from "./GroupMeeting.vue?vue&type=script&lang=ts"

import "./GroupMeeting.vue?vue&type=style&index=0&id=56c5b50a&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c5b50a"]])

export default __exports__